var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPotentialPhishing = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    viewBox: "0 0 27 27",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.286 4.56v3.161h-3.251l-1.378-1.378a.96.96 0 0 0-.682-.282H4.397v-1.5c0-.622.506-1.127 1.127-1.127h16.635c.621 0 1.127.505 1.127 1.127M23.286 9.282v2.39a7.63 7.63 0 0 0-4.446-1.422c-4.23 0-7.671 3.441-7.671 7.67 0 1.637.515 3.155 1.392 4.402H5.524a1.13 1.13 0 0 1-1.127-1.126V7.62h13.331l1.256 1.257c.261.26.607.403.975.403z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.84 11.81a6.12 6.12 0 0 0-6.111 6.11c0 3.37 2.74 6.111 6.11 6.111s6.111-2.741 6.111-6.11-2.74-6.111-6.11-6.111m1.72 5.675v2.57a2.664 2.664 0 0 1-2.66 2.66 2.664 2.664 0 0 1-2.661-2.66.78.78 0 0 1 1.56 0c0 .607.494 1.1 1.1 1.1s1.102-.493 1.102-1.1v-2.57a2.06 2.06 0 0 1-1.279-1.906 2.06 2.06 0 0 1 2.059-2.059c1.135 0 2.059.924 2.059 2.059 0 .86-.53 1.597-1.28 1.906m-.78-2.405a.499.499 0 1 0 .002.998.499.499 0 0 0-.001-.998"
  })));
};
export default SvgPotentialPhishing;